import { constants } from './../app-constants';
import { Component, OnInit } from '@angular/core';
import { TipoOsParamModel } from '../model/tipo-os-param.model';
import { TipoOsAtivoParamModel } from '../model';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {PathLocationStrategy} from '@angular/common';
import {PropertiesLocales} from '../util/properties-locale';
import {AdvGrowlService} from 'primeng-advanced-growl';
import {DialogService} from 'primeng/api';
import {DataService} from '../service/data.service';
import {AnexarArquivosDialogComponent} from '../anexar-arquivos-dialog/anexar-arquivos-dialog.component';
import {DomSanitizer} from '@angular/platform-browser';
import {AnexoIn} from '../model/anexo-in';
import {AnexoOsDialogComponent} from '../anexo-os-dialog/anexo-os-dialog.component';

@Component({
  selector: 'app-criar-osanexo',
  templateUrl: './criar-osanexo.component.html',
  styleUrls: ['./criar-osanexo.component.css'],
})
export class CriarOSAnexoComponent implements OnInit {
  anexos: Array<AnexoIn>;
  basePath: string;
  properties: PropertiesLocales = new PropertiesLocales();
  cols: any[];

  constructor(private loadingBar: NgxUiLoaderService,
              private advGrowlService: AdvGrowlService,
              private pathLocationStrategy: PathLocationStrategy,
              public dialogService: DialogService,
              private sanitizer: DomSanitizer,
              private data: DataService) { }

  ngOnInit() {
    this.buildDynamicHeaders();
    this.anexos = JSON.parse(localStorage.getItem(constants.anexosKey));
    if (!this.anexos) {
      this.anexos = [];
    }
  }


  buildDynamicHeaders() {
    this.basePath = this.pathLocationStrategy.getBaseHref();
    let local = localStorage.getItem(constants.locale);
    const uri = this.basePath.substring(7).replace('/', '').toString();

    if (!local.match(uri)) { // prevalece o locale definido na URL
      local = uri.replace('/', '');
    }

    if (local === 'pt') {
      this.cols = [
        { field: 'nomeArquivo', header: this.properties.items_steps_pt[22].label_cmp_anexo_nome },
        { field: 'descricao', header: this.properties.items_steps_pt[23].label_cmp_anexo_descricao },
        { header: this.properties.items_steps_pt[24].label_cmp_anexo_visualizar },
        { header: '' } // coluna de delete
      ];
    }

    if (local === 'es') {
      this.cols = [
        { field: 'nomeArquivo', header: this.properties.items_steps_es[22].label_cmp_anexo_nome },
        { field: 'descricao', header: this.properties.items_steps_es[23].label_cmp_anexo_descricao },
        { header: this.properties.items_steps_es[24].label_cmp_anexo_visualizar },
        { header: '' } // coluna de delete
      ];
    }

    if (local === 'en') {
      this.cols = [
        { field: 'nomeArquivo', header: this.properties.items_steps_en[22].label_cmp_anexo_nome },
        { field: 'descricao', header: this.properties.items_steps_en[23].label_cmp_anexo_descricao },
        { header: this.properties.items_steps_en[24].label_cmp_anexo_visualizar },
        { header: '' } // coluna de delete
      ];
    }
  }

  showAnexarArquivoDialog() {
    const dialogRef = this.dialogService.open(AnexarArquivosDialogComponent, {
      data: {
        anexosList: this.anexos
      },
      header: 'Anexar arquivo',
      width: '70%',
      contentStyle: {'max-height': '350px', 'overflow': 'auto'},
    });
    dialogRef.onClose.subscribe((re: any) => {
      if (re) {
        this.anexos.push(re);
      }
    });
  }

  visualizarArquivo(anexo: AnexoIn) {
    if (anexo && anexo.fileInBase64.startsWith('data:image/')) {
      this.showImagemAnexada(anexo);
    } else {
      this.downloadFile(anexo);
    }
  }

  showImagemAnexada (anexo: AnexoIn) {
    const ref = this.dialogService.open(AnexoOsDialogComponent, {
      data: anexo.fileInBase64,
      header: anexo.nomeArquivo,
      width: '70%',
      height: '70%'
    });
  }

  downloadFile(anexo: AnexoIn) {
    const source = anexo.fileInBase64;
    const link = document.createElement('a');
    link.href = source;
    link.download = anexo.nomeArquivo;
    link.click();
  }

  deletarAnexo(anexo: AnexoIn) {
    if (anexo && this.anexos) {
      let local = localStorage.getItem(constants.locale);
      const uri = this.basePath.substring(7).replace('/', '').toString();
      let message = '';
      if (!local.match(uri)) { // prevalece o locale definido na URL
        local = uri.replace('/', '');
      }

      if (local === 'pt') {
        message = 'Realmente deseja excluir o Anexo ' + anexo.nomeArquivo +
          '? Esta operação não pode ser desfeita, caso mude de ideia, o anexo deverá ser adicionado manualmente outra vez.';
      } else if (local === 'es') {
        message = '¿Realmente desea eliminar el Anexo ' + anexo.nomeArquivo +
          '? Esta operación no se puede deshacer, si cambia de opinión, el archivo adjunto debe volver a agregarse manualmente.';
      } else if (local === 'en') {
        message = 'Do you really wish to delete the Attatchment ' + anexo.nomeArquivo +
          '? This operation cannot be undone, if you change your mind, you must attach the file manually again.';
      }

      if (confirm(message)) {
        const index = this.anexos.indexOf(anexo);
        if (index >= 0) {
          this.anexos.splice(index, 1);
          const anexosLocal = JSON.parse(localStorage.getItem(constants.anexosKey));
          anexosLocal.splice(anexosLocal.indexOf(anexo), 1);
          localStorage.setItem(constants.anexosKey, JSON.stringify(anexosLocal));
        }
      }
    }
  }

}
